module.exports = __webpack_public_path__ + "img/C04TechRoyalRoads_ua.b9230520.webp";